import Accordion from './components/layout/Accordion';
import AnimateWhenVisible from './components/layout/AnimateWhenVisible';
import Carousel from "./components/layout/Carousel";
import CollapsibleActivator from "./components/layout/CollapsibleActivator";
import CollapsibleFAQ from "./components/layout/CollapsibleFAQ";
import DeferredBlock from "./components/layout/DeferredBlock";
import MobileScroller from "./components/layout/MobileScroller";
import PackSelector from "./components/layout/PackSelector";
import Parallax from "./components/layout/Parallax";
import Slideshow from "./components/layout/Slideshow";
import Sticky from "./components/layout/Sticky";
import SubNavigation from "./components/layout/SubNavigation";
import Tabs from "./components/layout/Tabs";
import TabContents from "./components/layout/TabContents";
import ImageTabs from "./components/layout/ImageTabs";
import Lightbox from "./components/content/Lightbox";

// fixme: These should probably all be page-specific scripts rather than global components
// fixme: Please retire these as their respective pages are phased out or refactored
import { DuviriHubsite } from "./components/content/duviri/index.js";
import { PowerPacks } from "./components/content/powerpacks/index.js";
import { PrimeResurgence } from "./components/content/primeresurgence/index.js";
import { Tennocon2024 } from "./components/content/tennocon2024/index.js";

const DATA_COMPONENT = "component"
const DATA_INITIALIZED = "initialized"
const SELECTOR_COMPONENT = "[data-" + DATA_COMPONENT + "]";

const matchMobileOnly = window.matchMedia("(max-width: 767px)");
const matchTabletOnly = window.matchMedia("(min-width: 768px) and (max-width: 1279)");
const matchTabletUp = window.matchMedia("(min-width: 768px)");
const matchDesktopOnly = window.matchMedia("(min-width: 1280px) and (max-width: 1919px)");
const matchDesktopUp = window.matchMedia("(min-width: 1280px)");
const matchWideUp = window.matchMedia("(min-width: 1920px)");

const componentTypes = {};

function registerComponent(type) {
    if (!type) {
        console.error(`Error: Attempted to register null or empty component type.`)
        return;
    }
    if (!type.name) {
        console.error(`Error: Attempted to register unnamed component type.`, type);
        return;
    }
    if (!type.initialize) {
        console.error(`Error: Attempted to register component type with no initializer.`, type);
        return;
    }

    componentTypes[type.name] = type;
}
function initializeComponents(context=null) {
    if (!context || !context.querySelector) context = document;

    const componentElements = context.querySelectorAll(SELECTOR_COMPONENT);
    componentElements.forEach(initializeComponent);
}
function initializeComponent(element) {
    const name = element.dataset[DATA_COMPONENT];
    const type = componentTypes[name];
    if (!name || !type) {
        console.error(`Error: Unrecognized component type specified "${name}"`, element);
        return;
    }

    if (type.alwaysInitialize || !element.dataset[DATA_INITIALIZED]) {
        type.initialize(element, PageComponents);
        element.dataset[DATA_INITIALIZED] = 'true';
    }
}

function finalizeComponents() {
    for (const key in componentTypes) {
        const type = componentTypes[key];
        if (type.finalize) type.finalize(PageComponents);
    }
}

let PageComponents = window.PageComponents = {
    componentTypes,
    registerComponent,
    beforeLoadCallbacks: [],
    afterLoadCallbacks: [],
    isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
    isAndroid: /Android/.test(navigator.userAgent),
    isMobileOnly: () => matchMobileOnly.matches,
    isTabletOnly: () => matchTabletOnly.matches,
    isTabletUp: () => matchTabletUp.matches,
    isDesktopOnly: () => matchDesktopOnly.matches,
    isDesktopUp: () => matchDesktopUp.matches,
    isWideUp: () => matchWideUp.matches,
};

PageComponents.beforeLoad = (callback) => {
    PageComponents.beforeLoadCallbacks.push(callback);
}
PageComponents.afterLoad = (callback) => {
    PageComponents.afterLoadCallbacks.push(callback);
}

if (window.PageComponentsBeforeLoadCallbacks) {
    for (const callback of window.PageComponentsBeforeLoadCallbacks) {
        PageComponents.beforeLoad(callback);
    }
}
if (window.PageComponentsAfterLoadCallbacks) {
    for (const callback of window.PageComponentsAfterLoadCallbacks) {
        PageComponents.afterLoad(callback);
    }
}

registerComponent(PackSelector);
registerComponent(Parallax);
registerComponent(Carousel);
registerComponent(MobileScroller);
registerComponent(SubNavigation);
registerComponent(Slideshow);
registerComponent(CollapsibleActivator);
registerComponent(CollapsibleFAQ);
registerComponent(AnimateWhenVisible);
registerComponent(Tabs);
registerComponent(TabContents);
registerComponent(ImageTabs);
registerComponent(Accordion);
registerComponent(Lightbox);

// Page load lifecycle handler
window.addEventListener('load', () => {

    // Pre-initialization callbacks
    PageComponents.beforeLoadCallbacks.forEach((callback) => {
        callback(window.PageComponents);
    });

    // Initialize standalone components
    initializeComponents();

    // Initialize components with global behavior
    DeferredBlock.init(PageComponents);
    Sticky.init(PageComponents);

    // fixme: These should probably all be page-specific scripts rather than global components
    // fixme: Please retire these as their respective pages are phased out or refactored
    if ( document.body.classList.contains( "duviri_paradox" ) ) {
        DuviriHubsite.init( PageComponents );
    }
    if ( document.getElementById( "power-packs" ) ) {
        PowerPacks.init( PageComponents );
    }
    if ( document.getElementById( "prime_resurgence" ) ) {
        PrimeResurgence.init( PageComponents );
    }
    if ( document.body.classList.contains( "tennocon_main" ) || document.body.classList.contains( "tennocon_tickets" ) ) {
        Tennocon2024.init( PageComponents );
    }

    // Run any finalization methods on components
    finalizeComponents();

    // Post-initialization callbacks
    PageComponents.afterLoadCallbacks.forEach((callback) => {
        callback(PageComponents);
    });

});
